'use strict';

var React = require('react');
var NewsTeaser = require('./NewsTeaser');
var LinkButton = require('../elements/LinkButton.jsx');


module.exports = React.createClass({
	displayName: 'NewsList',
	propTypes: {
		model: React.PropTypes.array.isRequired,
		hero: React.PropTypes.object
	},
	render: function () {

		var model = this.props.model;

		if (!model || !model.slice) {
			return false;
		}

		// Checks if urgent News block is active or not
		var hero = this.props.hero;
		if (!hero) {
			model.shift();
		}

		var firstItems = model.slice(0, 3);
		var lastItems = model.slice(3, 6);

		return (
			<section className="svtse_section">

				<div className="svtse_news">
					<div className="svtse_news__columns">
						<div className="svtse_news__columns-top">
							<a href="//www.svt.se/nyheter/" className="svtse_news-header__link">
								<h1 className="svtse_a11y-hidden">Nyheter från SVT Nyheter</h1>
								<figure className="svtse_news-header__figure">
									<img className="svtse_news-header__img" alt="SVT Nyheter logotyp" src="/static/svtse-render/images/logotypes/svt_nyheter_logo-420x87.png" />
								</figure>
							</a>
						</div>

						<div className="svtse_news__columns-bottom">

								<div className="svtse_grid">
									<div className="svtse_grid__col-full-halves--medium svtse_grid--no-top-padding">
										{firstItems.map(function (item, index) {
											return (
												<NewsTeaser model={item} key={index}/>
											);
										})}
									</div>
									<div className="svtse_grid__col-full-halves--medium svtse_grid--no-top-padding">
										{lastItems.map(function (item, index) {
											return (
												<NewsTeaser model={item} key={index}/>
											);
										})}
									</div>
								</div>

								<div className="svtse_news-navigation">
									<LinkButton url="//www.svt.se/nyheter/" theme="news" icon={['arrow-right','after',true]}>
										Mer på SVT Nyheter
									</LinkButton>
								</div>

						</div>
					</div>
				</div>
			</section>
		);
	}
});



/** WEBPACK FOOTER **
 ** ./app/components/news/News.jsx
 **/